module.exports = __webpack_public_path__ + "static/media/28.27d068a7.wav";